import React from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  IconButton,
} from "@mui/material";
import styled from "src/components/Ordering/components/BottomBasketPanel/styled";
import ProductItem from "src/components/ReservationProduct/components/ProductItem";
import { CrossClose } from "src/assets/icons/index";
import { colors } from "src/config/colors";
import { ProductOffersItemPharmaciesSchema2 } from "src/models/productPharmacies/getProductPharmacies";
import { ReservationProductParams } from "src/components/ReservationProduct/ReservationProduct";
import { ProductCart } from "src/redux/slice/basketSlice";
import {
  EnumMetrikActions,
  sendCustomYandexMetrik,
} from "src/config/analytics/sendCustomYandexMetrik";

interface BottomReservationPanelProps {
  isOpen: boolean;
  onClose: () => void;
  dataSelectedMapOffers: ProductOffersItemPharmaciesSchema2[];
  setOpenDetailModal: React.Dispatch<React.SetStateAction<boolean>>;
  imgSource: string;
  toBookClick: (
    arg0: ReservationProductParams,
    arg1: Omit<ProductCart, "slug">
  ) => void;
}

const BottomReservationPanel: React.FC<BottomReservationPanelProps> = ({
  onClose,
  isOpen,
  dataSelectedMapOffers,
  setOpenDetailModal,
  imgSource,
  toBookClick,
}) => {
  return (
    <Accordion
      elevation={1}
      square
      sx={{
        display: { xs: "flex", md: "none" },
        flexDirection: "column",
        maxHeight: "40%",
        position: "fixed",
        bottom: 68,
        width: "100%",
        left: 0,
        overflow: "scroll",
        boxShadow: "0px -4px 4px rgba(15, 15, 15, 0.1)",
        "&.Mui-expanded": {
          margin: 0,
        },
      }}
      expanded={isOpen}
      defaultExpanded
    >
      <AccordionSummary sx={{ display: "none" }} />
      <Box
        sx={{
          height: "40px",
          position: "sticky",
          top: 0,
          right: 0,
          backgroundColor: colors.white,
          zIndex: 1000,
        }}
      >
        <IconButton
          onClick={onClose}
          sx={{
            position: "absolute",
            top: "10px",
            right: "10px",
            zIndex: 1301,
          }}
        >
          <CrossClose color="#11193E" />
        </IconButton>
      </Box>
      <AccordionDetails sx={styled.textDetail}>
        {dataSelectedMapOffers.map((value, index) => (
          <ProductItem
            allowCart={value.offer.allowCart}
            exclusivePrice={value.offer.exclusivePrice}
            futureBooking={value.offer.futureBooking}
            isMapPriorOffer={value.offer.isMapPriorOffer}
            isListPriorOffer={value.offer.isListPriorOffer}
            productName={value.pharmacy_product_name}
            price={value.offer.price}
            pharmacyAddress={value.pharm.address}
            pharmacyName={value.pharm.name}
            key={value.offer.offerProductId + index}
            setOpenDetailModal={setOpenDetailModal}
            imgSrc={imgSource}
            toBookClick={() => {
              sendCustomYandexMetrik(EnumMetrikActions.bookingByMap);
              toBookClick(
                {
                  offerProductId: value.offer.offerProductId,
                  offerCompanyId: value.offer.companyId,
                },
                {
                  name: value.pharmacy_product_name,
                  productId: value.offer.offerProductId,
                  address: value.pharm.address,
                  imgSource,
                  pharmacyName: value.offer.companyName,
                  pharmacyPhone: value.pharm.salePhone,
                  pharmacySchedule: value.pharm.saleSchedule,
                  cartInfo: value.pharm.cartInfo,
                  bookingInfo: value.pharm.bookingInfo,
                  minPriceForBuy: value.pharm.minPriceForBuy,
                  fullName: value.pharmacy_product_name || "",
                  mnn: "",
                  price: value.offer.price,
                  brandName: value.pharm.brand_name,
                  counter: 1,
                  quantity: value.offer.quantity,
                }
              );
            }}
          />
        ))}
      </AccordionDetails>
    </Accordion>
  );
};

export default BottomReservationPanel;
